export default __webpack_public_path__ + "static/media/Gale.b60edf5c.jpg";